import request from "@/utils/request";

export const  gainUser =(query) =>{
    return request({
        url: "/authservice/linkActivity/user/info",
        method:"get",
        params: query
    })
}

export const  queryDict =(query) =>{
    return request({
        url: "/authservice/linkActivity/dict/queryDict",
        method:"get",
        params: query
    })
}

// 专题活动详情
export const  activityInfo =(query) =>{
    return request({
        url: "/authservice/linkActivity/activity/info",
        method:"get",
        params: query
    })
}

//竞赛报名
export const  signRace =(data) =>{
    return request({
        url: "/authservice/linkActivity/activity/create",
        method:"post",
        data: data
    })
}